import React from 'react'

export const IconCamera: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M8 5.333C6.555 5.333 5.333 6.554 5.333 8S6.554 10.667 8 10.667 10.667 9.446 10.667 8 9.446 5.333 8 5.333zm0 4c-.71 0-1.333-.623-1.333-1.333S7.29 6.667 8 6.667 9.333 7.29 9.333 8 8.71 9.333 8 9.333z" />
      <path d="M14 3.333h-2.391L9.804 1.528a.66.66 0 0 0-.47-.195H6.666h-.001a.663.663 0 0 0-.47.195L4.39 3.333H1.999A.667.667 0 0 0 1.332 4v8.667c0 .368.298.667.667.667h12a.667.667 0 0 0 .667-.667V4a.667.667 0 0 0-.667-.667zM13.333 12H2.666V4.667h2c.177 0 .347-.07.471-.195l1.805-1.805h2.115l1.805 1.805a.66.66 0 0 0 .47.195h2.001V12z" />
    </svg>
  )
}
